var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.146447 7.81311C-0.0488155 8.00838 -0.0488155 8.32496 0.146447 8.52022C0.341709 8.71548 0.658291 8.71548 0.853553 8.52022L4.33332 5.04045L7.81311 8.52024C8.00838 8.7155 8.32496 8.7155 8.52022 8.52024C8.71548 8.32498 8.71548 8.0084 8.52022 7.81313L5.04043 4.33334L8.52022 0.853553C8.71548 0.658291 8.71548 0.341708 8.52022 0.146446C8.32496 -0.0488155 8.00838 -0.0488155 7.81311 0.146446L4.33332 3.62624L0.853553 0.146468C0.658291 -0.0487943 0.341709 -0.0487943 0.146447 0.146468C-0.0488155 0.34173 -0.0488155 0.658312 0.146447 0.853575L3.62622 4.33334L0.146447 7.81311Z",
    fill: "#8997BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fd4b2f542e73bcf605f2bc27b93b1bd7.svg";
export { ForwardRef as ReactComponent };